const Id = {
    Footer: 'footer_banner',
    FooterMobile: 'footer_mobile_banner',
    Sidebar: 'sidebar_banner',
    Promo: 'promo_banner',
    Category1: 'category_banner_1',
    Category2: 'category_banner_2',
    Category3: 'category_banner_3',
    CategoryMid: 'category_middle_banner',
    ProductMid: 'product_middle_banner',
    ProductMidMobile: 'product_middle_mobile_banner',
    HomeSlider1: 'home_slider_1',
    HomeSlider2: 'home_slider_2',
    HomeSlider3: 'home_slider_3',
    HomeSlider4: 'home_slider_4',
    HomeMid1: 'home_middle_1x_1',
    HomeMid21: 'home_middle_2x_1',
    HomeMid22: 'home_middle_2x_2',
    HomeMid31: 'home_middle_3x_1',
    HomeMid32: 'home_middle_3x_2',
    HomeMid33: 'home_middle_3x_3',
    CategoryLandingTopSlider1: 'category_landing_top_slider_1',
    CategoryLandingTopSlider2: 'category_landing_top_slider_2',
    CategoryLandingTopSlider3: 'category_landing_top_slider_3',
    CategoryLandingTopSlider4: 'category_landing_top_slider_4',
    CategoryLandingFeaturedWeek1: 'category_landing_featured_week_1',
    CategoryLandingFeaturedWeek2: 'category_landing_featured_week_2',
    CategoryLandingFeaturedWeek3: 'category_landing_featured_week_3',
    CategoryLandingMiddle1: 'category_landing_middle_1',
    CategoryLandingMiddle2: 'category_landing_middle_2',
    CategoryLandingMiddle3: 'category_landing_middle_3',
    CategoryLandingMiddle4: 'category_landing_middle_4',
    CategoryLandingFeatured: 'category_landing_featured',
    CategoryLandingBrand1: 'category_landing_brand_1',
    CategoryLandingBrand2: 'category_landing_brand_2',
    CategoryLandingBrand3: 'category_landing_brand_3',
    CategoryLandingBrand4: 'category_landing_brand_4',
    CategoryLandingBrand5: 'category_landing_brand_5',
    CategoryLandingBrand6: 'category_landing_brand_6',
    CategoryLandingBrand7: 'category_landing_brand_7',
    CategoryLandingBrand8: 'category_landing_brand_8',
};

export default Id;